// extracted by mini-css-extract-plugin
module.exports = {"loaderHolder":"styles_loaderHolder__wO-Xb","rotating":"styles_rotating__TGvEi"};